import * as yup from "yup";

// passwordCheck -> password

// 비밀번호 변경
export const editPasswordValidation = yup.object({
  password: yup
    .string()
    .required("navBar.myAccount.popUp.changePassword.checkMsg1"),
  newPassword: yup
    .string()
    .matches(
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,16}$/,
      "navBar.myAccount.popUp.changePassword.checkMsg4"
    )
    .required(),
  newPasswordCheck: yup
    .string()
    .when("newPassword", (newPassword, field) =>
      newPassword
        ? field
            .required("navBar.myAccount.popUp.changePassword.checkMsg5")
            .oneOf(
              [yup.ref("newPassword")],
              "navBar.myAccount.popUp.changePassword.checkMsg5"
            )
        : field
    )
    .required("navBar.myAccount.popUp.changePassword.checkMsg5"),
});
